import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface ICategoryItem {
  readonly _id: string;
  readonly title: string;
  readonly subtitle?: string;
  readonly nodeId: string;
  readonly link?: string;
  readonly hidden?: boolean;
  readonly icon?: string; // URL to SVG
}

export interface ICategory {
  readonly id: string;
  readonly type: MESSAGES.CATEGORY;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly items: ICategoryItem[];
  readonly role?: string;
}

export const createCategory = (data): ICategory => ({
  id: data.id || uuid(),
  type: MESSAGES.CATEGORY,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  items: data.items,
});
